module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town")]), _vm._v(" "), _c('p', {
    staticClass: "ctr",
    attrs: {
      "id": "pz24-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#RR_23",
      "id": "CC_23"
    }
  }, [_vm._v(" Mayberry Molasses Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "tx6",
    attrs: {
      "id": "pz24-2"
    }
  }, [_c('i', [_vm._v(" It’s slow good. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAxN"
    }
  }, [_c('b', [_vm._v(" 1 cup whole-wheat flour ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAFqW"
    }
  }, [_c('b', [_vm._v(" 1 cup all-purpose flour ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAn82"
    }
  }, [_c('b', [_vm._v(" 1 teaspoon baking soda ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pA2b"
    }
  }, [_c('b', [_vm._v(" 1 teaspoon salt ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAZDX"
    }
  }, [_c('b', [_vm._v(" ½ cup sugar ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAHL"
    }
  }, [_c('b', [_vm._v(" ½ cup dark molasses ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAkMp"
    }
  }, [_c('b', [_vm._v(" 1½ cups milk (do not use skim) ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "pAEB"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("P")]), _vm._v("reheat the oven to 325°. Spray a 9×4-inch loaf pan with cooking spray. Sift together dry ingredients. Mix liquid ingredients; then add to dry mixture. Mix well with electric mixer. Pour into greased loaf pan. Bake for 1½ hours. Cool for 10 minutes in pan; then turn out and allow to cool completely. Delicious with cream cheese.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pAh_"
    }
  }, [_vm._v(" Freezes well.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pAZOJ"
    }
  }, [_vm._v(" Makes 1 loaf.")]), _vm._v(" "), _c('p', {
    staticClass: "txrr",
    attrs: {
      "id": "pAR16"
    }
  }, [_c('i', [_vm._v("Annette Davis—Greensboro, North Carolina")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0733690","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter23.vue
// module id = 132
// module chunks = 0